import { errorActions } from '@content-platform/web-angular-shared-util-error-handling';
export const LOAD = '[Application] LOAD';
export const LOAD_BY_ID = '[Application] LOAD BY ID';
export const LOAD_SUCCESS = '[Application] LOAD SUCCESS';
export const LOAD_BY_ID_SUCCESS = '[Application] LOAD BY ID SUCCESS';
export const LOAD_FAILED = '[Application] LOAD FAILED';
export const LOAD_BY_ID_FAILED = '[Application] LOAD BY ID FAILED';
export const UPDATE = '[Application] UPDATE';
export const UPDATE_SUCCESS = '[Application] UPDATE SUCCESS';
export const UPDATE_FAILED = '[Application] UPDATE FAILED';
export const DELETE = '[Application] DELETE';
export const DELETE_SUCCESS = '[Application] DELETE SUCCESS';
export const DELETE_FAILED = '[Application] DELETE FAILED';
export const CREATE = '[Application] CREATE';
export const CREATE_SUCCESS = '[Application] CREATE SUCCESS';
export const CREATE_FAILED = '[Application] CREATE FAILED';
export class Load {
    constructor(payload = null) {
        this.payload = payload;
        this.type = LOAD;
    }
}
export class LoadById {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_BY_ID;
    }
}
export class LoadSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_SUCCESS;
    }
}
export class LoadByIdSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOAD_BY_ID_SUCCESS;
    }
}
export class LoadFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = LOAD_FAILED;
    }
}
export class LoadByIdFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = LOAD_BY_ID_FAILED;
    }
}
export class Update {
    constructor(payload) {
        this.payload = payload;
        this.type = UPDATE;
    }
}
export class UpdateSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = UPDATE_SUCCESS;
    }
}
export class UpdateFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = UPDATE_FAILED;
    }
}
export class Delete {
    constructor(payload) {
        this.payload = payload;
        this.type = DELETE;
    }
}
export class DeleteSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = DELETE_SUCCESS;
    }
}
export class DeleteFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = DELETE_FAILED;
    }
}
export class Create {
    constructor(payload) {
        this.payload = payload;
        this.type = CREATE;
    }
}
export class CreateSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = CREATE_SUCCESS;
    }
}
export class CreateFailed extends errorActions.Fail {
    constructor() {
        super(...arguments);
        this.type = CREATE_FAILED;
    }
}
//# sourceMappingURL=application.actions.js.map